import React from "react";
import DropDown from "@/Frontend/Components/Header/DropDown";
import NavigationLink from "@/Components/NavigationLink";

function MenuItem({ item }) {
    const hasChildren = item.children && item.children.length > 0;

    return (
        <li className={hasChildren ? "apeex-menu-item-has-children" : "apeex-menu-item"}>
            <NavigationLink href={item.url} className="apeex-nav-link">
                {item.name}
            </NavigationLink>
            {hasChildren && (
                <DropDown>
                    <ul className="apeex-sub-menu">
                        {item.children.map((childItem) => (
                            <MenuItem key={childItem.id} item={childItem} />
                        ))}
                    </ul>
                </DropDown>
            )}
        </li>
    );
}

export default MenuItem;